import styled, { keyframes } from "styled-components";

/* ── Keyframes ──────────────────────────────────────── */
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const SigninContainer = styled.div`
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #faf7ff 0%, #f0e5ff 100%);
  position: relative;
  padding: 72px 20px;
`;

export const SigninWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 460px;
  background: #fff;
  border: 1px solid #eadcff;
  border-radius: 16px;
  padding: 40px 36px;
  box-shadow: 0 16px 45px rgba(80, 40, 120, 0.12);
  animation: ${fadeInUp} 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;

  @media screen and (max-width: 480px) {
    padding: 32px 22px;
    border-radius: 20px;
  }
`;

export const SigninP = styled.p`
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 4px;
  font-size: 14px;
  letter-spacing: 0.4px;
  color: #4a3c55;
  text-align: left;
  text-transform: uppercase;
`;

export const SigninInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #ddc9f2;
  margin-bottom: 18px;
  font-size: 15px;
  color: #241b2b;
  background: #fff;
  transition: all 0.3s ease;
  outline: none;
  font-family: inherit;

  &::placeholder {
    color: #9a8da4;
  }

  &:focus {
    border-color: #B05FFD;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(176, 95, 253, 0.15);
  }

  &:hover:not(:focus) {
    border-color: #b995dc;
  }
`;

export const SigninButton = styled.button`
  width: 100%;
  padding: 15px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #fff;
  background: #B05FFD;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(176, 95, 253, 0.25);
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 9px 22px rgba(176, 95, 253, 0.35);
    background: #9346df;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(176, 95, 253, 0.25);
  }
`;

export const SigninTitle = styled.h1`
  font-size: 28px;
  font-weight: 800;
  color: #241b2b;
  text-align: center;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
`;

export const SigninSubtitle = styled.p`
  font-size: 14px;
  color: #76677f;
  text-align: center;
  margin-bottom: 32px;
`;

export const Divider = styled.div`
  width: 50px;
  height: 3px;
  border-radius: 3px;
  background: #B05FFD;
  margin: 8px auto 28px;
`;

export const SigninLink = styled.span`
  color: #8d42d6;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #B05FFD;
    text-decoration: underline;
  }
`;

/* ── Password row ───────────────────────────────────── */
export const PasswordRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${SigninInput} {
    margin-bottom: 0;
    padding-right: 48px;
  }
`;

export const EyeButton = styled.span`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #8e7b99;
  font-size: 18px;
  display: flex;
  align-items: center;
  transition: color 0.2s ease;

  &:hover {
    color: #B05FFD;
  }
`;

/* ── Error text ─────────────────────────────────────── */
export const ErrorText = styled.p`
  color: #f87171;
  text-align: center;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(248, 113, 113, 0.08);
  border: 1px solid rgba(248, 113, 113, 0.2);
`;

/* ── Bottom text ────────────────────────────────────── */
export const BottomText = styled.p`
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #76677f;

  a {
    color: #8d42d6;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #B05FFD;
      text-decoration: underline;
    }
  }
`;

/* ── Branding ───────────────────────────────────────── */
export const BrandLogo = styled.div`
  text-align: center;
  margin-bottom: 8px;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(176, 95, 253, 0.35);
    box-shadow: 0 0 20px rgba(176, 95, 253, 0.15);
  }
`;
